"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChevronDown = function ChevronDown(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M16.5962 7.40382C15.5328 6.34046 14.1337 5.67871 12.6371 5.53131C11.1405 5.38391 9.63917 5.75999 8.3888 6.59546C7.13842 7.43093 6.21642 8.6741 5.77989 10.1132C5.34336 11.5522 5.4193 13.0981 5.99478 14.4875C6.57027 15.8768 7.60968 17.0236 8.93592 17.7325C10.2622 18.4414 11.7932 18.6685 13.2681 18.3751C14.743 18.0817 16.0706 17.286 17.0246 16.1236C17.9786 14.9611 18.5 13.5038 18.5 12C18.5023 11.1461 18.3353 10.3002 18.0085 9.51121C17.6817 8.72228 17.2017 8.00599 16.5962 7.40382Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12 16.5C11.9343 16.5001 11.8693 16.4872 11.8086 16.4621C11.7479 16.4369 11.6928 16.4001 11.6464 16.3536L7.64645 12.3536C7.55268 12.2598 7.5 12.1326 7.5 12C7.5 11.8674 7.55268 11.7402 7.64645 11.6464C7.74022 11.5527 7.86739 11.5 8 11.5C8.13261 11.5 8.25979 11.5527 8.35356 11.6464L12.3536 15.6464C12.4235 15.7164 12.4711 15.8055 12.4904 15.9025C12.5097 15.9994 12.4998 16.1 12.4619 16.1913C12.4241 16.2827 12.36 16.3608 12.2778 16.4157C12.1956 16.4707 12.0989 16.5 12 16.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12 16.5001C11.9011 16.5001 11.8044 16.4708 11.7222 16.4159C11.64 16.3609 11.5759 16.2828 11.5381 16.1915C11.5002 16.1001 11.4903 15.9996 11.5096 15.9026C11.5289 15.8056 11.5765 15.7165 11.6464 15.6466L15.6464 11.6466C15.7404 11.5536 15.8673 11.5016 15.9995 11.502C16.1316 11.5023 16.2583 11.555 16.3517 11.6484C16.4452 11.7419 16.4978 11.8685 16.4982 12.0007C16.4985 12.1328 16.4465 12.2597 16.3535 12.3537L12.3535 16.3537C12.3072 16.4002 12.2521 16.437 12.1914 16.4622C12.1307 16.4873 12.0657 16.5002 12 16.5001Z",
    fill: props.foregroundColor
  }));
};

ChevronDown.defaultProps = {
  altText: "Chevron Down",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
ChevronDown.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = ChevronDown;
exports.default = _default;